import { render, staticRenderFns } from "./AttendanceView.vue?vue&type=template&id=235d395a&"
import script from "./AttendanceView.vue?vue&type=script&lang=js&"
export * from "./AttendanceView.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceView.vue?vue&type=style&index=0&id=235d395a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports